import { render, staticRenderFns } from "./AddTaskList.vue?vue&type=template&id=97fbcffa"
import script from "./AddTaskList.vue?vue&type=script&lang=js"
export * from "./AddTaskList.vue?vue&type=script&lang=js"
import style0 from "./AddTaskList.vue?vue&type=style&index=0&id=97fbcffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports